<div @tooltip>{{ text }}</div>
